/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./smartGroupStatisticsCard.vue?vue&type=template&id=15ec0738&scoped=true&"
import script from "./smartGroupStatisticsCard.vue?vue&type=script&lang=js&"
export * from "./smartGroupStatisticsCard.vue?vue&type=script&lang=js&"
import style0 from "./smartGroupStatisticsCard.vue?vue&type=style&index=0&id=15ec0738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec0738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VProgressCircular,VRow})
